module.exports = __webpack_public_path__ + "img/tlt7.7b7bfd45.png";